module.exports = __webpack_public_path__ + "29e62f26c4dd3df69e22cec9e71131e6.svg";